import { render, staticRenderFns } from "./Stap1.vue?vue&type=template&id=40358f66&"
import script from "./Stap1.vue?vue&type=script&lang=js&"
export * from "./Stap1.vue?vue&type=script&lang=js&"
import style0 from "./Stap1.vue?vue&type=style&index=0&id=40358f66&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports